export enum AppMode {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
}
